<app-dialog [dialogWithInput]="dialog" title="Analyse de l'image" (closeEvent)="close()" [manualCloseManagement]="true">
    <app-drawing-on-image
            [imageUrl]="dialog.input.backgroundUrl"
            [drawingData]="dialog.input.drawingData"
            [defaultColor]="'red'"
            [options]="options"
            (changedEvent)="changed($event)">
        <app-select-filter-v2 elementsTmpl [elements]="categoryElements" [parentFormGroup]="formGroup"
                              parentFormControlName="categoryName"
        (_onSingleSelectionChange)="selectedCategoryChanged($event?.element)"></app-select-filter-v2>
    </app-drawing-on-image>
</app-dialog>
<!-- [drawingData]="dialog.input.drawingData" -->
